import { createReducer } from "reduxsauce";

import ReducerRegister from "../../../ReducerRegister";
import EditUnitService from "../../../../services/screens/admin/bookgroup/EditUnitService";
import { ActionTypes } from "../../../actionTypes/screens/admin/bookgroup/EditUnitActionTypes";
import AsyncActionReducers from "../../../AsyncActionReducers";
import _ from "lodash";

import * as Helper from "../../../../utils/Helper";
import UIDs from "../../../../UIDs";

const uid = UIDs.screens.admin.bookgroup.addmyunit;

//
// Actions
//
const Actions = {
    loadScreenViewAsync: vo => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.LOAD_SCREEN_VIEW_ASYNC, vo });

            EditUnitService.loadScreenView(
                vo,
                response => {
                    dispatch(Actions.loadScreenViewSuccess(response, vo));
                },
                error => {
                    dispatch(Actions.loadScreenViewFailure(error));
                }
            );
        };
    },

    loadScreenViewSuccess: (data, vo) => ({
        type: ActionTypes.LOAD_SCREEN_VIEW_SUCCESS,
        parentType: ActionTypes.LOAD_SCREEN_VIEW_ASYNC,
        postReducer: loadScreenViewSuccessPostReducer,
        data,
        vo
    }),

    loadScreenViewFailure: error => ({
        type: ActionTypes.LOAD_SCREEN_VIEW_FAILURE,
        parentType: ActionTypes.LOAD_SCREEN_VIEW_ASYNC,
        error
    }),

    saveUnitAsync: vo => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.SAVE_UNIT_ASYNC, vo });

            EditUnitService.saveUnit(
                vo,
                response => {
                    dispatch(Actions.saveUnitSuccess(response));
                },
                error => {
                    dispatch(Actions.saveUnitFailure(error));
                }
            );
        };
    },

    saveUnitSuccess: data => ({
        type: ActionTypes.SAVE_UNIT_SUCCESS,
        parentType: ActionTypes.SAVE_UNIT_ASYNC,
        data
    }),

    saveUnitFailure: error => ({
        type: ActionTypes.SAVE_UNIT_FAILURE,
        parentType: ActionTypes.SAVE_UNIT_ASYNC,
        error
    }),

    showModal: val => ({
         type: ActionTypes.SHOW_MODAL,
         val
    }),

    setUnitKind: val => ({
         type: ActionTypes.SET_UNIT_KIND,
         val
    }),
};

//
// Initial State
//
const INITIAL_STATE = {
    unit: {
        unitType: null,
        data: {
            title: null,
        }
    },
    showModal: true,
    order: null,
    resourceId: ""
};

//
// Reducers
//
const loadScreenViewSuccessPostReducer = (state, { data, vo }) => {
    let newUnit = _.clone(state.unit);
    let { unit, unitCount, ...others } = data;
    let { index, show, unitType } = vo;

    if (unit.data)
    {
        show = false;
        newUnit = { ...unit, data: JSON.parse(unit.data)};
    }
    else if(unitType === "PSDO1" || unitType === "PSSD1"){
        show = false;
        newUnit = { ...unit, data:{title:null}, unitType };
    }
    else
    {
        newUnit = { ...unit, data:{title:null} };
    }

    return { ...state, unit: newUnit, showModal: show, order: (index > 0 ? index : (unitCount + 1)), ...others, resourceId: Helper.generateUUID() };
};

const showModalReducer  = (state, { val }) => {
   return { ...state, showModal: val };
};

const setUnitKindReducer  = (state, { val }) => {
    let newUnit = _.clone(state.unit);
    console.log("newUnit=============");
    console.log(newUnit)
    if(val === "0" || val === "1") {
        newUnit.unitType = "PSZM1";
        newUnit.data.answerType = val === "0" ? 8 : 4;
    }else{
        newUnit.unitType = "POKA2";
        newUnit.singleUnits = [];
    }
    newUnit.data.title=null;

   return { ...state, unit: newUnit, showModal: false };
};

// Use reduxsauce's createReducer to make it clearer for
// each action handler
const mergedReducer = createReducer(INITIAL_STATE, {
    [ActionTypes.LOAD_SCREEN_VIEW_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.LOAD_SCREEN_VIEW_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.LOAD_SCREEN_VIEW_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.SAVE_UNIT_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.SAVE_UNIT_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.SAVE_UNIT_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.SHOW_MODAL]: showModalReducer,
    [ActionTypes.SET_UNIT_KIND]: setUnitKindReducer,
});

// Enable dynamically register and unregister reducer
const reducer = new ReducerRegister(uid, mergedReducer);

export { ActionTypes, Actions, reducer, INITIAL_STATE };
